import React from 'react'
import './Warehousing.css'

const providesService = (val) =>
    val === 'yes' || val === 'Yes' || val === '1' || val === 1

const Warehousing = ({ transporter_data }) => {
    const warehouse = transporter_data?.warehousing_services ?? 'Details not available'
    const hasWarehouse = warehouse && warehouse !== 'Details not available'

    if (hasWarehouse && providesService(warehouse.provideService)) {
        return (
            <div className="warehousingcard" style={{ marginTop: '3%' }}>
                <div className="warehousingcontainer row">
                    <div className="col-12">
                        <span className="data_header padding-text"><b>Warehousing Services</b></span>
                    </div>
                    <div className="col">
                        <div className="warehousing"><span>{warehouse.area ? `${warehouse.area} sq.ft` : ''}</span></div>
                        <div className="warehousing"><span>{warehouse.hubs ? `${warehouse.hubs} hubs` : ''}</span></div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="warehousingcard" style={{ marginTop: '3%' }}>
            <div className="warehousingcontainer row">
                <div className="col-12">
                    <span className="data_header padding-text"><b>Warehousing Services</b></span>
                </div>
                <div className="col">
                    <div className="warehousing padding-text"><span>Details not available</span></div>
                </div>
            </div>
        </div>
    )
}

export default Warehousing
